import React from 'react';
import { FieldErrors } from './FieldErrors';
export const YesNoInput = (props) => {
    const onChange = (event) => {
        props.onChange(event.currentTarget.value === 'true');
    };
    return (React.createElement("div", { className: "input__radios" },
        React.createElement("div", { className: "input__radio-label" }, props.label),
        React.createElement("div", { className: "input__radio-options" },
            React.createElement("div", { className: "input__radio-option" },
                React.createElement("label", { "data-testid": `${props.name}_yes` },
                    React.createElement("input", { type: "radio", value: "true", name: props.name, onChange: onChange, checked: props.value === true }),
                    React.createElement("span", { className: "input__radio-option-label" }, "Yes"))),
            React.createElement("div", { className: "input__radio-option" },
                React.createElement("label", { "data-testid": `${props.name}_no` },
                    React.createElement("input", { type: "radio", value: "false", name: props.name, onChange: onChange, checked: props.value === false }),
                    React.createElement("span", { className: "input__radio-option-label" }, "No")))),
        React.createElement(FieldErrors, { errors: props.errors, name: props.name })));
};
